interface ErrorContext {
  [key: string]: unknown;
}

interface ErrorLogData {
  message: string;
  timestamp: string;
  context?: ErrorContext;
  stack?: string;
}

export const logError = (message: string, context?: ErrorContext, error?: Error): void => {
  const logData: ErrorLogData = {
    message,
    timestamp: new Date().toISOString(),
    context,
  };

  if (error?.stack) {
    logData.stack = error.stack;
  }

  console.error('[DPEWizard Error]', logData);
};

export const logWarning = (message: string, context?: ErrorContext): void => {
  const logData = {
    message,
    timestamp: new Date().toISOString(),
    context,
  };

  console.warn('[DPEWizard Warning]', logData);
};
